import { useQuery } from "@tanstack/react-query";
import adminApiClient, { ExploreFavoriteStats } from "../../api/admin";

const useExploreFavoritesStats = (days: number, enabled: boolean) => {
  return useQuery<ExploreFavoriteStats[]>({
    queryKey: ["exploreFavoritesStats", days],
    queryFn: () => adminApiClient.getExploreFavoritesStats(days),
    enabled,
  });
};

export default useExploreFavoritesStats;
